export default __webpack_public_path__ + "static/media/PE.950be7fc.svg";